<!--
  ~ Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div id="merchantDetail">
  <h1 class="mb-5 mt-2 pl-2">Create New Merchant</h1>
  <div class="row">
    <div class="col-md-10">
      <form
        [formGroup]="createMerchant"
        class="needs-validation form-horizontal"
        novalidate
      >
        <fieldset class="mb-3">
          <div class="col-md-12">
            <legend class="row ml-sm-0 mb-3 borderDivide">
              <div class="borderSeparation">Preferred Vendor</div>
            </legend>
          </div>
          <div class="offset-md-3 form-group fieldIsRequired">
            <label class="col-sm-8 control-label"> Preferred Vendor </label>
            <div class="col-md-8">
              <select
                class="form-control"
                name="vendorType"
                id="vendorType"
                formControlName="processor"
                (change)="vendorTypeChange()"
                [ngClass]="{
                  'is-invalid':
                    form.processor?.invalid && form.processor?.touched
                }"
              >
                <ng-container *ngFor="let vendor of singleVendorType">
                  <option [value]="vendor.key">
                    {{ vendor.value }}
                  </option>
                </ng-container>
              </select>
              <div
                class="formValidationMessage"
                role="alert"
                *ngIf="form.processor.dirty || form.processor.touched"
              >
                <div class="mt-1">
                  <div *ngIf="form.processor.errors?.required">
                    Field is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="mb-3">
          <div class="col-md-12">
            <legend class="row ml-sm-0 mb-3 borderDivide">
              <div class="borderSeparation">General Merchant Information</div>
            </legend>
          </div>
          <app-general-info-edit
            [parentGroup]="createMerchant"
            [generalInfo]="generalInfoFormGroup"
            [isEditable]="false"
            [merchant]="merchant"
            [hiddenField]="false"
          >
          </app-general-info-edit>
        </fieldset>
        <fieldset
          class="mb-3"
          *ngIf="this.merchantService.isInstaMed(merchant)"
        >
          <div class="col-md-12">
            <legend class="row ml-sm-0 mb-3 borderDivide">
              <div class="borderSeparation">Payment Processor Information</div>
            </legend>
          </div>
          <app-instamed-details-edit
            [instamedFormGroup]="this.instamedFormGroup"
          ></app-instamed-details-edit>
        </fieldset>
        <fieldset
          class="mb-3"
          *ngIf="this.merchantService.isGlobalPayments(merchant)"
        >
          <div class="col-md-12">
            <legend class="row ml-sm-0 mb-3 borderDivide">
              <div class="borderSeparation">Payment Processor Information</div>
            </legend>
          </div>
          <app-global-payments-details-edit
            [globalPaymentsFormGroup]="this.globalPaymentsFormGroup"
          ></app-global-payments-details-edit>
        </fieldset>
        <fieldset class="mb-3">
          <div class="col-md-12">
            <legend class="row ml-sm-0 mb-3 borderDivide">
              <div class="borderSeparation"></div>
            </legend>
          </div>
          <div class="offset-md-3">
            <div class="col-md-8">
              <button
                (click)="saveMerchant()"
                class="btn btn-primary"
                [disabled]="actionInProgress"
              >
                <span>
                  <fa-icon [icon]="faPlus" size="sm"></fa-icon>
                </span>
                Create New Merchant
                <span
                  *ngIf="actionInProgress"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</div>
